import { render, staticRenderFns } from "./AttachedRolesToPosition.vue?vue&type=template&id=0df30ebc"
import script from "./AttachedRolesToPosition.vue?vue&type=script&lang=js"
export * from "./AttachedRolesToPosition.vue?vue&type=script&lang=js"
import style0 from "./AttachedRolesToPosition.vue?vue&type=style&index=0&id=0df30ebc&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports